import { Box } from "@mui/material";
import { WizardQuestions_AttachmentFragment } from "../../documents/WizardQuestions.generated.js";

const SIZE = 56;

/** The first image a question or option carries, if any. */
export const WizardQuestionMedia = ({
  media,
}: {
  media: ReadonlyArray<WizardQuestions_AttachmentFragment>;
}) => {
  const image = media.find(m => m.mimeType.startsWith("image/"));

  if (!image) return null;

  return (
    <Box
      component="img"
      src={image.url}
      alt={image.title}
      sx={{
        width: SIZE,
        height: SIZE,
        objectFit: "cover",
        borderRadius: 1,
        flexShrink: 0,
      }}
    />
  );
};
